export default __webpack_public_path__ + "static/media/Attribute_Constitution.57804723.png";